import type { Components } from '@/api/generated/api';
import { TemplateSetSource } from '@/api/generated/api.enum';
import type { ComputedRef, Ref } from 'vue';
import { useCurrentTenantQuery } from './useCurrentTenantQuery';
import { useCurrentTenantMutation } from './useCurrentTenantMutation';

export type TenantTemplateUpsertAction = keyof typeof TemplateSetSource;

interface ICurrentTenantComposable {
  currentTenant: ComputedRef<Components.Schemas.TenantDto | null>;
  isCurrentTenantPending: ComputedRef<boolean>;
  currentTenantOwnersAndAdmins: ComputedRef<Components.Schemas.UserDataDto[]>;
  editCurrentTenant: (dto: Components.Schemas.UpdateTenantDto) => Promise<void>;
  uploadLogo: (file: File) => Promise<void>;
  removeLogo: () => Promise<void>;
  isUploadingLogo: Ref<boolean>;
  updateSchoolLevels: (levels: number[]) => Promise<void>;
  completeAdministrationSetup: () => Promise<void>;
  markCompetenceSetupChoiceDialogSeen: () => Promise<void>;
  refresh: () => Promise<void>;
}

export const useCurrentTenant = (): ICurrentTenantComposable => {
  const query = useCurrentTenantQuery();
  const mutation = useCurrentTenantMutation();
  return { ...query, ...mutation };
};
